<template>
  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>
    <!-- TAB目录 -->

    <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
    >
      <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
      >
        <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
            <Badge
                :overflow-count="10000000"
                :count="v.badge.count"
                v-if="v.badge && v.badge.count"
                :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
                   {{ v.label }}
                 </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>
    <!-- <Row :gutter="8" style="margin:0px 0 0 0;width:100%" v-if="menus && menus.length > 0">
      <Menu mode="horizontal" :active-name="menu_name" @on-select="selectMenu" style="width:100%">
        <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
            {{ v.label }}
          </MenuItem>
        </div>
      </Menu>
    </Row> -->
    <!-- 筛选 -->
    <Row
        :gutter="8"
        style="margin: 20px 0 0 0; width: 100%"
        v-if="filters && filters.length > 0 && orderstype != '订单管理'"
    >
      <Form
          ref="formQuery"
          :label-width="100"
          :label-position="left"
          :label-colon="true"
          :model="query"
          style="
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          flex-wrap: wrap;
          width: 80%;
        "
      >
        <Col
            span="3"
            :xxl="6"
            :xl="4"
            :lg="6"
            :md="8"
            :sm="12"
            :xs="24"
            style="
            display: flex;
            flex-direction: row-reverse;
            position: absolute;
            right: 20px;
          "
        >
          <Button
              icon="ios-search"
              type="info"
              @click="search"
              style="width: 90px"
          >搜索</Button
          >
          <Button
              icon="ios-close-circle"
              type="error"
              @click="clearFilter"
              style="width: 90px; margin-right: 15px"
          >重置</Button
          >
        </Col>

        <template v-for="(v, k) in filters">
          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-if="v.type === 'inputs'"
              style="margin: 0px 0 10px 0; float: right; display: flex"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <div style="margin-bottom: 0; display: flex">
                <Input
                    :key="k"
                    :placeholder="'最小' + v.label"
                    clearable
                    v-model="query[v.name1]"
                ></Input>
                <div>~</div>
                <Input
                    :key="k"
                    :placeholder="'最大' + v.label"
                    clearable
                    v-model="query[v.name2]"
                ></Input>
              </div>
            </FormItem>
          </Col>
          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-if="
              v.type === 'string' || v.type === 'text' || v.type === 'input'
            "
              style="margin: 0px 0 10px 0; float: right; display: flex"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <Input
                  :key="k"
                  :placeholder="v.label"
                  clearable
                  v-model="query[v.name]"
              ></Input>
            </FormItem>
          </Col>

          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-if="v.type === 'search'"
              style="margin: 0px 0 10px 0; float: right; display: flex"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <!-- v-if="v.name=='search'||hospitaltype=='商品列表'" -->
              <Input
                  :key="k"
                  clearable
                  v-model="select"
                  :placeholder="v.label"
                  style="width: 184px; align: center"
              ></Input>
            </FormItem>
          </Col>

          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-else-if="v.type === 'select'"
              style="margin: 0px 0 10px 0"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <i-select
                  :key="k"
                  v-model="query[v.name]"
                  clearable
                  style="width: 186px"
                  :multiple="v.multiple ? true : false"
                  :disabled="v.disabled ? true : false"
                  :placeholder="'请选择' + v.label"
                  :filterable="true"
                  @on-change="v.onChange"
              >
                <Option
                    :value="s.value"
                    v-for="(s, sk) in v.dropList || []"
                    :key="sk"
                >{{ s.name }}</Option
                >
              </i-select>
            </FormItem>
          </Col>
          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-else-if="v.type === 'datetimerange'"
              style="margin: 0px 0 10px 0; float: right"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <DatePicker
                  clearable
                  :key="k"
                  type="datetimerange"
                  style="width: 186px"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择时间"
                  @on-change="
                  (val) => {
                    timeDateChange(val, v.name);
                  }
                "
              ></DatePicker>
            </FormItem>
          </Col>
          <Col
              :key="k"
              v-else-if="v.type === 'distpicker'"
              style="margin: 0px 0 10px 0; float: right"
          >
            <FormAddress
                @on-change="
                (val) => {
                  onAddressChange(val, v.name);
                }
              "
                style="width: 100%"
            ></FormAddress>
          </Col>
          <Col
              :key="k"
              span="3"
              :xxl="6"
              :xl="7"
              :lg="9"
              :md="12"
              :sm="12"
              :xs="24"
              v-else-if="v.type === 'addressInfo'"
              style="width: auto; margin: 0px 0 10px 0; float: right"
          >
            <FormItem :label="v.label" style="margin-bottom: 0">
              <v-distpicker
                  :disabeld="disabeld"
                  type="addressInfo"
                  :province="province"
                  :city="city"
                  :area="area"
                  @selected="v.onSelect"
              ></v-distpicker>
            </FormItem>
          </Col>
        </template>
      </Form>
    </Row>

    <!-- 操作 -->
    <Row
        :gutter="8"
        style="margin: 20px 0 0 0; width: 100%"
        v-if="actions && actions.length > 0 && orderstype !== '订单管理'"
    >
      <div v-for="(v, k) in actions" :key="k">
        <!-- <Col span="3" :xxl="3" :xl="4" :lg="6" :md="8" :sm="12" :xs="12" v-auth="v.auth"> -->
        <Button
            :size="v.size || 'default'"
            :type="v.type || 'warning'"
            v-auth="v.auth"
            :icon="v.icon || ''"
            @click="v.onClick"
        >{{ v.label }}</Button
        >
        <!-- </Col> -->
      </div>
    </Row>

    <!-- 表格 -->
    <Row
        :gutter="8"
        style="margin: 20px 0 0 0; width: 100%"
        v-if="orderstype !== '订单管理'"
    >
      <edit-table
          ref="tablelist"
          :query="query"
          :table="table"
          :order="table.order || ''"
          :rowClassName="table.rowClassName"
          :output="table.output"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
          :handleSpan="handleSpan"
          @on-select="handleSelect"
          @on-edit="handleEdit"
          @on-info="handleInfo"
          @on-del="handleDel"
          @on-row-click="handleRowClick"
      >
        <div slot="header">
          <tableHeader></tableHeader>
        </div>
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div
              v-for="(v, k) in tactions"
              :key="k"
              style="margin-right: 10px; display: inline-flex"
          >
            <Button
                :size="v.size || 'default'"
                :type="v.type || 'primary'"
                v-auth="v.auth"
                :icon="v.icon || ''"
                :disabled="v.disabled"
                @click="v.onClick"
                :style="v.style"
            >{{ v.label }}</Button
            >
          </div>
        </div>
        <div slot="footer">
          <tableFooter></tableFooter>
        </div>
      </edit-table>
      <!-- <Badge   v-if="hospitaltype=='购物车'" :count="num" style="margin-top: 50px" > <Button @click="handleSubmit" style="background: #00c261;color: #f8f8f9;">提交申请</Button></Badge> -->
    </Row>

    <div v-if="orderstype == '订单管理'">
      <div style="height: 100px">
            <Space
                direction="vertical"
                size="large"
                type="flex"
                style="position: absolute;"
            >
              <Row v-if="filters && filters.length > 0">
                <Form style="position: relative; left: 5px; display: flex">
                  <Button
                      icon="ios-search"
                      type="info"
                      @click="search"
                      style="
                      position: absolute;
                      left: 140%;
                      bottom: 45px;
                      width: 90px;
                    "
                  >搜索</Button
                  >
                  <template v-for="(v, k) in filters">
                    <Col :key="k">
                      <FormItem :label="v.label" style="margin-bottom: 0">
                        <Input
                            :key="k"
                            @keydown.enter="search"
                            :placeholder="v.label"
                            clearable
                            v-model="query[v.name]"
                            style="
                            position: relative;
                            left: 75px;
                            bottom: 40px;
                            width: 200px;
                            margin: 5px;
                          "
                        ></Input>
                      </FormItem>
                    </Col>
                  </template>
                </Form>
              </Row>
              <Button
                  icon="md-download"
                  style="
                  margin: 5px;
                  position: relative;
                  left: 190%;
                  bottom: 83px;
                "
                  @click="exportTable"
              >导出</Button
              >
            </Space>
        <Space direction="vertical" style="position: absolute; top: 100px">
          <Space wrap>
            <Button type="info" style="margin: 5px" @click="this.search"
            >全部</Button
            >
            <template v-for="(v, k) in tactions">
              <Button
                  style="margin-left: 5px"
                  :key="k"
                  :size="v.size || 'default'"
                  :type="v.type"
                  v-auth="v.auth"
                  :icon="v.icon || ''"
                  @click="v.onClick(v.status)"
              >{{ v.label }}
              </Button>
            </template>
            <template v-for="(v, k) in actions">
              <Button
                  style="margin-left: 5px"
                  :key="k"
                  :size="v.size || 'default'"
                  :type="v.type"
                  v-auth="v.auth"
                  :icon="v.icon || ''"
                  @click="v.onClick(v.time)"
              >{{ v.label }}</Button
              >
            </template>
          </Space>
        </Space>
          </div>


      <div>
        <edit-table
            ref="tablelist"
            :query="query"
            :table="table"
            :order="table.order || ''"
            :rowClassName="table.rowClassName"
            :output="table.output"
            :border="table.border"
            :stripe="table.stripe"
            :header="table.header"
            :footer="table.footer"
            :columns-list="tableCols"
            :handleSpan="handleSpan"
            @on-select="handleSelect"
            @on-edit="handleEdit"
            @on-info="handleInfo"
            @on-del="handleDel"
        >
        </edit-table>
        <!-- <Page :total="100" show-sizer style="position:relative;left: 35%;top:20px"/> -->
      </div>
    </div>

    <!-- 审核弹框 -->
    <Modal v-model="pass.model" width="360">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="md-information-circled"></Icon>
        <span>审核</span>
      </p>
      <div>
        <Input
            placeholder="请输入审核意见"
            type="textarea"
            :autosize="{ minRows: 5 }"
            v-model="pass.content"
        ></Input>
      </div>
      <div slot="footer">
        <Button
            size="large"
            :type="pass.status == 1 ? 'success' : 'error'"
            long
            @click="handlePass"
            :loading="pass.sloading"
        >{{ pass.status == 1 ? "通过" : "拒绝" }}</Button
        >
      </div>
    </Modal>
    <!-- 视频播放 -->
    <!-- <div slot="footer">
        <vioder></vioder>
    </div> -->
    <Modal
        v-model="pass2.model2"
        width="830"
        :closable="false"
        :mask-closable="false"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="md-information-circled"></Icon>
        <span>{{ pass2.content }}</span>
      </p>
      <div style="text-align: center">
        <video
            id="play"
            width="500"
            height="300"
            controls="controls"
            v-if="pass2.content == '视频介绍'"
        ></video>
        <audio
            id="play"
            width="500"
            height="300"
            controls="controls"
            v-if="pass2.content == '语音介绍'"
        ></audio>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handlePass2">播放</Button>
        <Button type="default" @click="handleCancel">取消</Button>
      </div>
    </Modal>

    <Modal
        v-model="flag"
        width="830"
        :closable="false"
        :mask-closable="false"
        @on-ok="ok"
    >
      <Tabs value="name1">
        <TabPane label="订单信息" name="name1">
          <Space direction="vertical" size="large">
            <Space style="display: block; margin: 5px">
              物流公司
              <Select v-model="model" style="width: 200px">
                <Option
                    v-for="item in logistics"
                    :value="item.id"
                    :key="item.id"
                >{{ item.logisticsType }}</Option
                >
              </Select>
            </Space>
          </Space>
        </TabPane>
      </Tabs>
    </Modal>

    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component
        v-for="(item, index) in extRender || []"
        :key="index"
        :ref="item"
        :is="item"
    ></component>
  </div>
</template>
<script>
import baseView from "./baseView.vue";
import FormAddress from "../common/form/formAddress";
import EditTable from "../common/table/editTable.vue";

export default {
  extends: baseView,
  components: {
    tableHeader: null,
    tableFooter: null,
    FormAddress,
    EditTable,
  },
  data() {
    return {
      title: "",
      hospitaltype: "",
      selectLike: "",
      table: {
        mname: "",
        key: "",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        rowClassName: () => {},
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      item: [],
      drawerBox: false, // 侧栏详情
      drawerName: "info", // 动态渲染的组件
      drawerKv: "", // 详情主键
      pass: {
        model: false,
        sloading: false,
        kv: null,
        status: 0,
        content: "",
        modelMap: false,
      },
      pass2: {
        model2: false,
        kv: null,
        content: "",
      },
      selected: "",
      router: { add: "", edit: "" },
      actions: [],
      tactions: [],
      menu_name: "",
      menus: [],
      query: {},
      filters: [],
      tableCols: [],
      logisticsData: [],
      orderLength: "",
      saledLength: "",
    };
  },
  extRender() {
    // 动态选择组件，["xxx","bbb"]
    return null;
  },
  watch: {
    query() {
      this.$forceUpdate();
    },
    filters() {
      this.$forceUpdate();
    },
  },
  created() {
    this.$bus.on("addShop", () => {
      this.search();
    });
    this.$bus.on("approveAdd", () => {
      this.search();
    });
    let route = this.$route;
    console.log(this.hospitaltype);
    console.log("route", route);
    if (route) {
      this.menu_name = route.name;
    }
    // 表格行样式
    this.table.rowClassName = (row, index) => {
      return this.rowClassName(row, index);
    };
  },
  mounted() {
    this.search();
    // 获取目录上的徽标
    this.getMenuBadge();
  },
  methods: {
    getMenuBadge() {
      let that = this;
      if (this.menus) {
        // 查询徽标数
        for (let index = 0; index < this.menus.length; index++) {
          const ee = this.menus[index];
          if (ee.badge && ee.badge.scene && ee.badge.mname) {
            let q = {};
            q.scene = ee.badge.scene;
            $utils.api
                .load(ee.badge.url || ee.badge.mname, q, "get", {
                  loading: false,
                  login: false,
                  toast: false,
                  toasterror: false,
                })
                .then((res) => {
                  if (res.status && res.data) {
                    let badge = res.data[ee.badge.scene];
                    if (badge) {
                      that.menus[index].badge.count = badge;
                      that.$forceUpdate();
                    }
                  }
                  if (res.status && res.total) {
                    let badge = res.total;
                    if (badge) {
                      that.menus[index].badge.count = badge;
                      that.$forceUpdate();
                    }
                  }
                });
          }
        }
      }
    },
    search() {
      console.log("list search");
      // 取消多选框，否则有残留数据
      this.selected = "";
      this.$refs.tablelist.page.page = 1;
      this.$refs.tablelist.init();
    },
    exportTable() {
      $utils.api.load(this.table.url.export).then((resp) => {
        console.log(resp);
      });
    },

    onAddressChange(val, field) {
      console.log(val, "xxxxxx");
      let province = val.province || {};
      let city = val.city || {};
      let area = val.area || {};
      console.log(val.province);
      this.query[field] = {
        field: field,
        province_code: province.code,
        city_code: city.code,
        area_code: area.code,
      };
      console.log("timeDateChange fieldobj", this.query[field]);
    },

    clearFilter() {
      // window.location.reload(true);
      this.$refs.formQuery.resetFields();
      for (let index = 0; index < this.filters.length; index++) {
        const element = this.filters[index];
        if (element) {
          this.query[element.name] = "";
          console.log(element.name, "aaaaaaa");
        }
      }
      //列表单独字段请求置空
      // this.query = {}
      this.$refs.tablelist.page.page = 1;
      this.$refs.tablelist.init();
    },
    exportData(filename = "", is_all = 0) {
      // 调用table导出
      const ids = this.selected;
      console.log("exportData ids", ids);
      console.log("exportData is_all", is_all);
      this.$refs.tablelist.exportData(4, ids, filename, is_all);
    },
    // downloadCodeImg(filename = '', is_all = 0) {
    //   // 调用table导出
    //   const ids = this.selected
    //   console.log('downloadCodeImg ids', ids)
    //   console.log('downloadCodeImg is_all', is_all)
    //   this.$refs.tablelist.downloadCodeImg(4, ids, filename, is_all)
    // },
    selectMenu(name) {
      console.log("selectMenu ", name);
      if (this.menu_name !== name) {
        $utils.url.push({ name: name });
      }
    },
    loadFiltersFieldDrop(type, field, param = {}) {
      // 通过pk查询字典数据
      let q = param;
      let apiname = "";
      if (type == "shop") {
        apiname = "shopDropList";
      }
      if (type == "shop_store") {
        apiname = "shopStoreDropList";
      }
      if (type == "product") {
        apiname = "productDropList";
      }
      if (type == "product_class") {
        apiname = "productClassDropList";
      }
      if (type == "help_class") {
        apiname = "helpClassDropList";
      }
      if (type == "auth_type") {
        apiname = "authTypeDropList";
      }
      if (!apiname) {
        return;
      }
      $utils.api.load(apiname, q).then((res) => {
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.value;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == field && element.type == "select") {
              this.filters[index]["dropList"] = dropList;
            }
          }
          console.log("dropList " + field, dropList);
        }
      });
    },
    // 通过name查询filters下标
    indexOfName(name = "", filters = []) {
      if (!name) {
        return -1;
      }
      if (!filters) {
        filters = this.filters || [];
      }
      for (let index = 0; index < this.filters.length; index++) {
        const element = this.filters[index];
        if (element && element.name == name) {
          return index;
        }
      }
      return -1;
    },
    timeDateChange(val, field) {
      console.log("timeDateChange", val, field);
      this.query.begin = val[0];
      this.query.end = val[1];
      // this.query[field]  = {
      //   // field: field,
      //   // begin: val[0],
      //   // end: val[1],
      // }
      console.log("timeDateChange fieldobj", this.query[field]);
    },
    // 合并行列
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // console.log('handleSpan', row, column, rowIndex, columnIndex)
    },
    rowClassName(row, index) {
      // console.log(row, index)
      return "";
    },
    toAdd(e, name = "") {
      let url = this.table.router.add || this.toLine(this.table.mname) + "_add";
      if (name && name !== "" && name !== undefined) {
        url = name;
      }
      console.log("toAdd", url, name, e);
      $utils.url.push({ name: url, query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row[this.table.key];
      console.log(kv);
      let url =
          this.table.router.edit || this.toLine(this.table.mname) + "_edit";
      console.log("handleEdit", row);
      $utils.url.push({ name: url, query: { action: "edit", kv: kv } });
    },
    handleSelect(selected, row) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
      }
      this.item = selected;
      this.selected = ids_arr.join(",");
    },
    handleDel(row) {},
    handleInfo(row) {
      let kv = row[this.table.key];
      // 打开详情
      this.drawerBox = true;
      this.drawerKv = kv;
      // this.drawerIndex = 0
      // let kv = row[this.table.key]
      // let url = this.table.router.info || this.toLine(this.table.mname) + "_info"
      // console.log('handleInfo', row)
      // $utils.url.push({name: url, query: {kv: kv} })
    },
    handlePass() {
      let q = {};
      q.kv = this.pass.kv;
      q.status = this.pass.status;
      q.pass_content = this.pass.content;
      if (q.kv == "" || q.status == "" || q.pass_content == "") {
        return $utils.toast.error("请求数据错误");
      }
      this.$set(this.pass, "sloading", true);
      $utils.api
          .load(this.table.url.pass || this.table.mname + "Pass", q)
          .then((res) => {
            $utils.toast.text(res.message);
            if (res.status) {
              this.$set(this.pass, "model", false);
              this.$set(this.pass, "sloading", false);
              this.search();
            }
          })
          .catch((e) => {
            console.log(e);
            this.$set(this.pass, "sloading", false);
            $utils.toast.error("数据异常");
          });
    },
    // 视频语音播放
    handlePass2() {
      let q = {};
      q.kv = this.pass2.kv;
      let url = this.pass2.kv;
      console.log(q, "4444444");

      this.video = url;
      this.videoElem = document.getElementById("play").src = url;
      this.videoElem = document.getElementById("play").play();
      this.$set(this.pass2, "sloading", true);
    },
    handleCancel() {
      this.videoElem = document.getElementById("play").pause();
      this.pass2.model2 = false;
    },
    // 模态框
    handleRender(e) {
      if (e.row.logisticsId != 0) {
        this.logisticsSelect(e.row.logisticsId);
        this.$Modal.confirm({
          width: "1000px",
          closable: "true",
          draggable: "true",
          render: () => {
            console.log(e);
            if (e.row.orderStatus == 2) {
              return (
                  <Tabs value="name1">
                    <TabPane label="订单信息" name="name1">
                      <Space direction="vertical" size="large">
                        <Space style="display:block;margin:5px">
                          订单编号
                          <Input
                              readonly
                              value={e.row.orderNumber}
                              style="width: 300px;margin:5px"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          收货人
                          <Input
                              readonly
                              value={e.row.createBy}
                              style=" width:300px;margin:18px;"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          收货地址
                          <Input
                              placeholder="Enter name"
                              style="width: 300px;margin:5px"
                              value="安阳市第六人民医院"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          物流公司
                          <Input
                              readonly
                              style="width: 300px;margin:5px"
                              value={this.logisticsData.logisticsType}
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          物流单号
                          <Input
                              placeholder="Enter name"
                              style="width: 300px;margin:5px"
                              value="SF2022190510"
                          />
                        </Space>
                      </Space>
                    </TabPane>
                  </Tabs>
              );
            } else {
              return (
                  <Tabs value="name1">
                    <TabPane label="订单信息" name="name1">
                      <Space direction="vertical" size="large">
                        <Space style="display:block;margin:5px">
                          订单编号
                          <Input
                              readonly
                              value={e.row.orderNumber}
                              style="width: 300px;margin:5px"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          收货人
                          <Input
                              readonly
                              value={e.row.createBy}
                              style=" width:300px;margin:18px;"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          收货地址
                          <Input
                              readonly
                              style="width: 300px;margin:5px"
                              value="第六人民医院"
                          />
                        </Space>
                        <Space style="display:block;margin:5px">
                          物流公司
                          <Input
                              readonly
                              style="width: 300px;margin:5px"
                              value={this.logisticsData.logisticsType}
                          />
                          {/* <Select style="width: 300px;margin:5px" default-label="顺丰" clearable={true}>
                                      <Option label="顺丰"></Option>
                                    </Select> */}
                        </Space>
                        <Space style="display:block;margin:5px">
                          物流单号
                          <Input
                              readonly
                              placeholder="Enter name"
                              style="width: 300px;margin:5px"
                              value="SF2022190510"
                          />
                        </Space>
                        <Button
                            type="success"
                            slot="footer"
                            onClick={() => {
                              this.$Modal.remove();
                            }}
                        >
                          确认
                        </Button>
                      </Space>
                    </TabPane>
                  </Tabs>
              );
            }
          },
        });
      } else {
        this.$Modal.confirm({
          width: "1000px",
          closable: "true",
          draggable: "true",
          render: () => {
            return (
                <Tabs value="name1">
                  <TabPane label="订单信息" name="name1">
                    <Space direction="vertical" size="large">
                      <Space style="display:block;margin:5px">
                        订单编号
                        <Input
                            readonly
                            value={e.row.orderNumber}
                            style="width: 300px;margin:5px"
                        />
                      </Space>
                      <Space style="display:block;margin:5px">
                        收货人
                        <Input
                            readonly
                            value={e.row.createBy}
                            style=" width:300px;margin:18px;"
                        />
                      </Space>
                      <Space style="display:block;margin:5px">
                        收货地址
                        <Input
                            readonly
                            style="width: 300px;margin:5px"
                            value="第六人民医院"
                        />
                      </Space>
                      <Space style="display:block;margin:5px">
                        物流公司
                        <Input
                            readonly
                            style="width: 300px;margin:5px"
                            value="暂无物流信息"
                        />
                        {/* <Select style="width: 300px;margin:5px" default-label="顺丰" clearable={true}>
                                      <Option label="顺丰"></Option>
                                    </Select> */}
                      </Space>
                      <Space style="display:block;margin:5px">
                        物流单号
                        <Input
                            readonly
                            placeholder="Enter name"
                            style="width: 300px;margin:5px"
                            value="SF2022190510"
                        />
                      </Space>
                      <Button
                          type="success"
                          slot="footer"
                          onClick={() => {
                            this.$Modal.remove();
                          }}
                      >
                        确认
                      </Button>
                    </Space>
                  </TabPane>
                </Tabs>
            );
          },
        });
      }
    },
    // 搜索物流
    logisticsSelect(e) {
      $utils.api.load(`/admin/logisticsType/selectById?id=${e}`).then((res) => {
        this.logisticsData = res.data;
      });
    },

    // 签收
    handleSign(e) {
      let p = {};
      p.id = e.row.id;
      p.orderStatus = e.row.orderStatus + 1;
      $utils.api
          .load(`/admin/hospitalOrder/update`, p, "get")
          .then((res) => {
            if (res.status) {
              $utils.toast.success("保存成功");
              this.search();
            }
          })
          .catch((e) => {
            $utils.toast.error("保存异常" + e.message);
          });
    },
    // 点击列表
    handleRowClick(e) {
      if (typeof this.RowCLick == "function") {
        this.RowCLick(e);
      }
    },
    approveAdd() {
      this.$bus.emit("approveAdd");
      this.$Modal.remove();
      let q = this.item;
      for (let index = 0; index < q.length; index++) {
        q[index].deskId = this.deskData.rows[0].id;
      }
      $utils.api.load(`admin/approve/add`, q, "Post").then((res) => {
        if (res.code === 200) {
          $utils.toast.success(res.msg);
          this.$refs.tablelist.page.page = 1;
          this.$refs.tablelist.init();
        }
      });
    },
  },
};
</script>
<style lang="less">
.modelMap {
  position: relative;
}

#container {
  margin: 0 auto;
}

.ivu-modal-confirm-footer {
  display: none;
}

.single-page {
  overflow: hidden;
}
</style>